import React, { useState } from 'react'
import axios from 'axios'
import {
  Envelope,
  Clock,
  Person,
  CameraVideo,
  Send,
  Eraser,
  ChatDots,
  ArrowRightCircle
} from 'react-bootstrap-icons'

export default function Contact() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: ''
  })
  const [status, setStatus] = useState('idle')

  const handleChange = e => {
    const { name, value } = e.target
    setFormData(prev => ({
      ...prev,
      [name]: value
    }))
  }

  const handleClear = () => {
    setFormData({
      name: '',
      email: '',
      message: ''
    })
    setStatus('idle')
  }

  const handleSubmit = async e => {
    e.preventDefault()

    if (!formData.name.trim() || !formData.email.trim() || !formData.message.trim()) {
      return
    }

    try {
      setStatus('submitting')

      const response = await axios.post(
        'https://bcsoftwareapi-hxeqbcbkh8gwhjdv.ukwest-01.azurewebsites.net/api/contactUs',
        {
          name: formData.name.trim(),
          email: formData.email.trim(),
          message: formData.message.trim(),
          websiteId: 4
        }
      )

      if (response.status === 200) {
        setStatus('success')
      } else {
        setStatus('error')
      }
    } catch (error) {
      setStatus('error')
    }
  }

  return (
    <section id="contact" className="py-5 section-tint contactSection">
      <div className="container">
        <div className="contactHeading text-center mb-5">
          <div className="eyebrowWrap justify-content-center">
            <span className="eyebrowLine"></span>
            <p className="aboutEyebrow mb-0">Get in touch</p>
            <span className="eyebrowLine"></span>
          </div>

          <h1 className="brand-text-dark mb-3">Contact</h1>
          <p className="contactIntro mb-0">
            Enquiries, availability, and next steps.
          </p>
        </div>

        <div className="row g-4">
          <div className="col-12 col-lg-5">
            <div className="contactCard h-100">
              <div className="contactCardIcon">
                <ChatDots />
              </div>

              <h3 className="contactCardHeading">Start your enquiry</h3>

              <p className="contactLead mb-4">
                Once you have submitted an enquiry, I will get in touch with you
                within two working days. Please note that response times may vary
                over bank holidays.
              </p>

              <div className="contactInfoList">
                <div className="contactInfoItem">
                  <div className="contactInfoIcon">
                    <Envelope />
                  </div>
                  <div>
                    <div className="contactInfoLabel">Email</div>
                    <div className="contactInfoValue">
                      admin@journeywithjones.co.uk
                    </div>
                  </div>
                </div>
              </div>

              <div className="contactMetaList mt-4">
                <div className="contactMetaItem">
                  <Clock />
                  <span>Working hours: evenings, Friday mornings, and weekends</span>
                </div>

                <div className="contactMetaItem">
                  <Person />
                  <span>Age range: adults aged 18 and over</span>
                </div>

                <div className="contactMetaItem">
                  <CameraVideo />
                  <span>Online platforms: Zoom or Teams</span>
                </div>
              </div>
            </div>
          </div>

          <div className="col-12 col-lg-7">
            <div className="contactCard contactFormCard h-100">
              <div className="contactFormTop mb-4">
                <div>
                  <div className="contactFormTitle">Send a message</div>
                  <div className="contactFormText">
                    Fill in the form below, and I will get back to you as soon as possible.
                  </div>
                </div>

                <div className="contactReplyTime">
                  <ArrowRightCircle />
                  <span>Typical reply time: 24 to 48 hours</span>
                </div>
              </div>

              {status === 'submitting' && (
                <div className="contactStatusText">
                  Submitting...
                </div>
              )}

              {status === 'success' && (
                <div className="contactStatusText">
                  Message sent. I will get back to you as soon as possible.
                </div>
              )}

              {(status === 'idle' || status === 'error') && (
                <form id="contactForm" onSubmit={handleSubmit}>
                  <div className="row g-3">
                    <div className="col-12 col-md-6">
                      <label htmlFor="contactName" className="form-label contactLabel">
                        Name
                      </label>
                      <input
                        type="text"
                        className="form-control form-control-lg contactInput"
                        id="contactName"
                        name="name"
                        value={formData.name}
                        onChange={handleChange}
                        autoComplete="name"
                        required
                      />
                    </div>

                    <div className="col-12 col-md-6">
                      <label htmlFor="contactEmail" className="form-label contactLabel">
                        Email
                      </label>
                      <input
                        type="email"
                        className="form-control form-control-lg contactInput"
                        id="contactEmail"
                        name="email"
                        value={formData.email}
                        onChange={handleChange}
                        autoComplete="email"
                        required
                      />
                    </div>

                    <div className="col-12">
                      <label htmlFor="contactMessage" className="form-label contactLabel">
                        Message
                      </label>
                      <textarea
                        className="form-control contactInput contactTextarea"
                        id="contactMessage"
                        name="message"
                        value={formData.message}
                        onChange={handleChange}
                        rows="6"
                        required
                      ></textarea>
                      <div className="form-text contactHelpText">
                        Share what you would like support with and any helpful context.
                      </div>
                    </div>

                    <div className="col-12">
                      <div className="d-flex flex-column flex-sm-row gap-2">
                        <button type="submit" className="contactBtnPrimary flex-fill">
                          <Send />
                          <span>Send message</span>
                        </button>

                        <button
                          type="button"
                          className="contactBtnSecondary flex-fill"
                          onClick={handleClear}
                        >
                          <Eraser />
                          <span>Clear</span>
                        </button>
                      </div>
                    </div>

                    {status === 'error' && (
                      <div className="col-12">
                        <div className="contactStatusText">
                          Something went wrong. Please try again.
                        </div>
                      </div>
                    )}
                  </div>
                </form>
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}